import { render, staticRenderFns } from "./ProductCategoryList.vue?vue&type=template&id=77ff5b48&scoped=true&"
import script from "./ProductCategoryList.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff5b48",
  null
  
)

export default component.exports